import { isArray, isNull, isString, isUndefined } from 'lodash'

interface Parameter {
  name: string
  value: string | string[] | undefined | null
}

/**
 * Create a query string with the given parameters
 * @param parameters The original url parameters
 * @param parametersToAdd The parameters to add
 * @param parametersToRemove The parameters to remove. They will be removed before adding the new parameters
 * @returns The new query string
 */
export const createQueryString = (
  parameters: URLSearchParams | undefined,
  parametersToAdd?: Parameter[],
  parametersToRemove?: string[]
) => {
  const parameters_ = new URLSearchParams((parameters ?? '').toString())

  if (parametersToRemove) {
    for (const parameter of parametersToRemove) {
      parameters_.delete(parameter)
    }
  }

  if (parametersToAdd) {
    for (const parameter of parametersToAdd) {
      if (
        isNull(parameter.value) ||
        isUndefined(parameter.value) ||
        (isArray(parameter.value) && parameter.value.length === 0)
      ) {
        continue
      }

      if (isString(parameter.value)) {
        parameters_.set(parameter.name, parameter.value)
        continue
      }

      for (const value of parameter.value) {
        parameters_.append(parameter.name, value)
      }
    }
  }
  return parameters_.toString()
}
